module.exports = __webpack_public_path__ + "img/reserve2.d7c1575e.svg";